













































import { NcToken } from "@ncstat/parser";
import Vue from "vue";
import Component from "vue-class-component";
import Lexer from "./components/Lexer.vue";

@Component({
  components: {
    Lexer
  }
})
export default class App extends Vue {
  drawer = null;

  created() {
    this.$vuetify.theme.dark = true;
  }

  handleTokens({ tokens }: { tokens: NcToken[]}) {
    console.log(tokens);
  }
}
